import React, {useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import isURL from 'validator/lib/isURL';

const useStyles = makeStyles((theme) => ({

})); 


const EditSeminarDialog = ({isDialogOpen, setIsDialogOpen, editSeminar, setEditSeminar, saveCallback, autoCompletes}) => {
    const classes = useStyles();
    
    const [seminar, setSeminar] = useState({ id: "", title:"", host:"", city:"",  number: "", link: "", audience: "", cancelled:"", date: null, end_date: null, date_time:"", academic_year: "", description:""});
    const [errMsg, setErrMsg] = useState('');

    const validateURL = (e) => {
        const link = e.target.value;
        setSeminar({ ...seminar, link });
        setErrMsg(isURL(link) ? "" : "ungültige URL");
    };
    
    useEffect(() => {
        setSeminar({ ...editSeminar });
    }, [editSeminar]);
    
    return (    
        <Dialog
            open={ isDialogOpen }
            onClose={() => {setIsDialogOpen(false)}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {seminar.id ? "Fortbildung ändern" : "Neue Fortbildung hinzufügen"}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            id="edit-seminar-title"
                            label="Titel"
                            placeholder="Titel"
                            margin="normal"
                            variant="outlined"
                            required={true}
                            fullWidth={true}
                            value={seminar.title}
                            onChange={(e)=> setSeminar({ ...seminar, title: e.target.value })}
                            multiline
                            rows={2}
                            autoFocus
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            disablePortal
                            freeSolo
                            id="edit-seminar-host"
                            renderInput={(params) => <TextField {...params} label="Veranstalter" />}
                            placeholder="Veranstalter"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            value={seminar.host}
                            onInputChange={(e,newValue)=> setSeminar({ ...seminar, host: newValue })}
                            options={autoCompletes.hosts}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            disablePortal
                            freeSolo
                            id="edit-seminar-cities"
                            renderInput={(params) => <TextField {...params} label="Ort" />}
                            placeholder="ort"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            value={seminar.city}
                            onInputChange={(e,newValue)=> setSeminar({ ...seminar, city: newValue })}
                            options={autoCompletes.cities}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                        id="edit-seminar-audience"
                            label="Zielgruppen"
                            placeholder="Zielgruppen"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            value={seminar.audience}
                            onChange={(e)=> setSeminar({ ...seminar, audience: e.target.value })}
                            multiline
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} sx={{width:"100%"}}>
                            <DatePicker
                                inputFormat="dd.MM.yyyy"
                                mask="__.__.____"
                                label="Start-Datum"
                                value={seminar.date}
                                sx={{ width: "100%" }}
                                
                                onChange={(e) => {
                                    setSeminar({ ...seminar, date: e})
                                }}
                                renderInput={(params) => <TextField {...params} fullWidth/>}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                inputFormat="dd.MM.yyyy"
                                mask="__.__.____"
                                label="End-Datum"
                                value={seminar.end_date}
                                onChange={(e) => {
                                    setSeminar({ ...seminar, end_date: e })
                                }}
                                renderInput={(params) => <TextField {...params} fullWidth/>}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="edit-seminar-datetime"
                            label="Datum und Uhrzeit“"
                            placeholder="Datum und Uhrzeit“"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            value={seminar.date_time || ""}
                            onChange={(e)=> setSeminar({ ...seminar, date_time: e.target.value })}
                            multiline
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="edit-seminar-number"
                            label="LV-Nr./Anmeldung"
                            placeholder="LV-Nr./Anmeldung"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            value={seminar.number}
                            onChange={(e)=> setSeminar({ ...seminar, number: e.target.value })}
                            multiline
                        />
                        <TextField
                            error={errMsg ? true : false}
                            helperText={errMsg}
                            id="training-link"
                            label="Anmeldelink"
                            placeholder="https://..."
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            autoFocus
                            value={seminar.link || ""}
                            onChange={validateURL }
                            multiline
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="edit-seminar-cancelled"
                            label="Status"
                            placeholder="Status"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            value={seminar.cancelled}
                            onChange={(e)=> setSeminar({ ...seminar, cancelled: e.target.value })}
                            multiline
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="edit-seminar-academic_year"
                            label="Studienjahr"
                            placeholder="Studienjahr"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            value={seminar.academic_year}
                            onChange={(e)=> setSeminar({ ...seminar, academic_year: e.target.value })}
                            multiline
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="edit-seminar-description"
                            label="Beschreibung"
                            placeholder="Beschreibung"
                            margin="normal"
                            variant="outlined"
                            fullWidth={true}
                            value={seminar.description}
                            onChange={(e)=> setSeminar({ ...seminar, description: e.target.value })}
                            multiline
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={() => { 
                        setIsDialogOpen(false);
                        setEditSeminar({ id: "", title:"", host:"", city:"",  number: "", link: "", audience: "", cancelled:"", date: null, end_date: null, date_time:"", academic_year: "", description:""});
                        }
                    }
                >
                    abbrechen
                </Button>
                <Button 
                    variant='contained'
                    onClick={() => { 
                        setIsDialogOpen(false);
                        saveCallback(seminar);
                        setEditSeminar({ id: "", title:"", host:"", city:"",  number: "", link: "", audience: "", cancelled:"", date: null, end_date: null, date_time:"", academic_year: "", description:""});
                        }
                    }
                    disabled={ !seminar.title }
                >
                    speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EditSeminarDialog;